var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPictoElephant(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 135,
    viewBox: "0 0 165 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M153.349 131.391C166.315 131.391 162.393 131.391 162.593 131.391",
    stroke: "#504FE4",
    strokeWidth: 7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83 82C83 82 109 91 86.5 133",
    stroke: "#504FE4",
    strokeWidth: 7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M124 62C145.348 74.3423 153.635 99.0361 157 134",
    stroke: "#504FE4",
    strokeWidth: 7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M123.04 7.00006C66 -8.5 87.0193 48.7065 126.361 63.6537",
    stroke: "#504FE4",
    strokeWidth: 7
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 133C29.2484 63.4181 89 78 93 91.5",
    stroke: "#504FE4",
    strokeWidth: 7
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M139.408 20.8786C169.231 19.6248 159.5 131.753 159.5 133",
    stroke: "#504FE4",
    strokeWidth: 7
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3289 19.7958C83.9932 22.2806 103.12 22.55 139.408 20.8953",
    stroke: "#504FE4",
    strokeWidth: 7
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.329 19.8845C1.07248 16.5787 38.449 98.7575 42.5 132",
    stroke: "#504FE4",
    strokeWidth: 7
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7499 44.4596C22.1724 46.9746 5.64474 82.1723 3.5 131.5",
    stroke: "#504FE4",
    strokeWidth: 7
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M40.75 44.5192C54.8418 42.6323 53.3 86.3894 53.3 132.5",
    stroke: "#504FE4",
    strokeWidth: 7
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4407 69.1234C81.1218 70.8911 76.3724 93.5043 75.3 130.5",
    stroke: "#504FE4",
    strokeWidth: 7
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4409 69.1631C106.285 67.8421 113.9 96.4159 117.2 129",
    stroke: "#504FE4",
    strokeWidth: 7
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0 131.391C13.2361 131.391 16.9536 131.391 17.1579 131.391",
    stroke: "#504FE4",
    strokeWidth: 7
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6052 131.391C52.6686 131.391 56.6185 131.391 56.8355 131.391",
    stroke: "#504FE4",
    strokeWidth: 7
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8486 131.391C85.7343 131.391 89.6343 131.391 89.8486 131.391",
    stroke: "#504FE4",
    strokeWidth: 7
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M113.671 131.391C126.907 131.391 130.625 131.391 130.829 131.391",
    stroke: "#504FE4",
    strokeWidth: 7
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M120.5 4L125.5 72L127.34 128.5",
    stroke: "#504FE4",
    strokeWidth: 7
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoElephant);
export default __webpack_public_path__ + "static/media/pictoElephant.51d411f4381d7d4f5de1f73fd827295f.svg";
export { ForwardRef as ReactComponent };